import { render, staticRenderFns } from "./room-dd.vue?vue&type=template&id=38f7be89&"
import script from "./room-dd.vue?vue&type=script&lang=ts&"
export * from "./room-dd.vue?vue&type=script&lang=ts&"
import style0 from "./room-dd.vue?vue&type=style&index=0&id=38f7be89&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports